<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-md-8 text-center">
      <h2>Welcome to HP Admin</h2>
      <p class="text-muted mt-3"></p>
    </div>
  </div>
</div>
